module.exports = __webpack_public_path__ + "img/rank_2.966f953.png";